<template>
	<!-- 租赁订单 -->
	<div class="legacy-order-page">
        <h2>租赁订单</h2>
        <div class="legacy-order-surface">
		<order-tabs :show-title="false" v-model="tab" :tabs-list="tabList" @tab-click="getData">
		</order-tabs>
        <details class="legacy-filter"><summary><img src="@/assets/images/appointments/d70dd.svg" alt="" />筛选</summary>		<order-search :start="startDate" :end="endDate" @handle-start="handleStart" @handle-end="handleEnd"
			@handle-search="getData">
		</order-search>
</details>
        <p v-if="listLoading" role="status">正在读取订单…</p>
        <div v-else-if="listError" role="alert"><p>{{ listError }}</p><button type="button" @click="getData">重新加载订单</button></div>
        <div v-else-if="!orderTableList.length" class="legacy-empty">暂无该状态的租赁订单</div>
		<!-- 表格 -->
		<div class="legacy-table-scroll" tabindex="0" aria-label="订单列表，可横向滚动查看价格与操作"><center-order-table v-if="!listLoading && !listError && orderTableList.length" table-title="租赁订单" :table-list="orderTableList">
			<!-- 价格 -->
			<template #price="{price}">
				<div>{{"¥ "+ price}}</div>
			</template>
			<!-- 实付款 -->
			<template #payment="{price}">
				<div>{{"¥ "+ price}}</div>
			</template>
			<!-- 交易状态 -->
			<template #status="{status, id}">
				<div>{{status | ostatus}}</div>
				<router-link :to="{
                        name: 'clothesPay',
                        query:{id}
                    }">
					订单详情
				</router-link>
			</template>
			<!-- 操作 -->
			<template #handle="{row}">
				<!-- 我的订单 -->
				<div>
					<!-- 去支付 -->
					<router-link :to="{
                            name: 'clothesPay',
                            query:{id: row.orderID}
                        }" class="center-lease-handle" v-if="row.orderStatus==0">
						去支付
					</router-link>
					<a href="javascript:;" v-if="row.orderStatus == 0" @click="handleStatus(row.orderID, -1)">
						取消订单
					</a>
					<!-- 	<div
					    class="center-lease-handle"
					    v-if="row.orderStatus==0"
						@click="handleStatus(row.orderID, -1)"
						>
					    取消订单
					</div> -->
					<!-- 归还 -->
					<a href="javascript:;" class="center-lease-handle" v-if="row.orderStatus==4"
						@click="handleStatus(row.orderID, 5)">
						归还
					</a>
				</div>
			</template>
		</center-order-table></div>
        </div>
	</div>
</template>

<script>
	import {
		mapState,
		mapMutations,
		mapActions
	} from 'vuex'
	import order from '@/mixins/centerOrder'
    import request from '@/tool/request'
    import API from '@/tool/api'

	export default {
		filters: {
			// 订单状态过滤器
			ostatus(val) {
				switch (val) {
					case 0:
						return "待付款";
						break;
					case 1:
						return "待接单";
						break;
					case 2:
						return "已同意";
						break;
					case 3:
						return "已拒绝";
						break;
					case 4:
						return "租赁中";
						break;
					case 5:
						return "等待租方确认服饰无破损";
						break;	
					case 9:
						return "已完成";
						break;
					case -1:
						return "取消";
						break;
					case -2:
						return "已过期";
						break;
				}
			},
		},
		mixins: [order],
		data() {
			return {
				tab: "-3",
                orderTableList: [], listLoading: false, listError: "", listGeneration: 0,
				tabList: [{
						value: "-3",
						label: "全部",
					},
					{
						value: "0",
						label: "待付款",
					},
					{
						value: "1",
						label: "待确认",
					},
					{
						value: "4",
						label: "租赁中",
					},
					{
						value: "5",
						label: "待租方确认无破损",
					},
					{
						value: "-1",
						label: "已取消",
					},
					{
						value: "-2",
						label: "过期订单",
					}
				]
			}
		},
		computed: mapState({
			user_id: state => state.user.user_id
		}),
		methods: {
			...mapMutations([
				'handleLoading',
			]),
			...mapActions([
				'handleOrderStatus'
			]),
			getParams() {
				let userID = this.user_id,
					fromTime = this.startDate,
					toTime = this.endDate,
          orderType = 1,
					orderStatus = this.tab == '-3' ? '' : this.tab;
				return this.$qs.stringify({
					userID,
					fromTime,
					toTime,
					orderStatus,
          orderType,
					type: 2
				})
			},
            async getData() {
                const generation = ++this.listGeneration; this.listLoading = true; this.listError = ''; this.orderTableList = [];
                try {
                    const response = await request({ method: 'POST', url: API.order.ownLeaseOrders, data: this.getParams() });
                    if (generation !== this.listGeneration) return;
                    if (!response || !response.data || response.data.code != 200 || !Array.isArray(response.data.result)) throw new Error(response && response.data && response.data.message || '订单读取失败');
                    this.orderTableList = response.data.result;
                } catch (error) { if (generation === this.listGeneration) this.listError = error.message || '订单读取失败'; }
                finally { if (generation === this.listGeneration) this.listLoading = false; }
            },
			getStatusParams(orderID, status) {
				let userID = this.user_id,
					url = API.order.ownLeaseOrderStatus,
					params = this.$qs.stringify({
						userID,
						orderID,
						status
					});
				return {
					url,
					params
				}
			},
			handleStatus(orderID, status) { // 改变订单状态
                const operationOwner = this.user_id;
				let {
					url,
					params
				} = this.getStatusParams(orderID, status);

				this.$confirm(`是否归还？`, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
                    if (operationOwner !== this.user_id) return;
					this.handleLoading(true);
					return this.handleOrderStatus({
						url,
						params
					})
				}).then(res => {
                    if (operationOwner !== this.user_id || !res) return;
					this.$message({
						showClose: true,
						message: res.data.message,
						type: res.data.code == 200 ? 'success' : 'error'
					})
					this.getData()
				}).catch(() => {}).finally(() => {
					this.handleLoading(false);
				})
			}
		},
        watch: { user_id() { this.listGeneration += 1; this.orderTableList = []; if (this.user_id) this.getData(); } },
        beforeDestroy() { this.listGeneration += 1; },
		beforeRouteEnter(to, from, next) {
			next(vm => {
				vm.getData();
			})
		},
		beforeRouteLeave(to, from, next) {
			this.listGeneration += 1; this.orderTableList = [];
			next();
		}
	}
</script>

<style scoped>
.legacy-table-scroll { max-width:100%; overflow-x:auto; }.legacy-table-scroll ::v-deep .el-table { min-width:900px; }
.legacy-order-page { color:#24242a; }.legacy-order-surface { padding:28px 32px; border-radius:24px; background:white; min-height:530px; }.legacy-filter summary { display:flex; gap:6px; align-items:center; justify-content:flex-end; padding:8px 0; color:#6b5dd5; font-size:14px; cursor:pointer; }.legacy-filter img { width:16px; height:16px; }.legacy-order-page ::v-deep .el-tabs__nav { border:0; }.legacy-order-page ::v-deep .el-tabs__item { border:0; margin-right:12px; padding:0 14px; }.legacy-order-page ::v-deep .el-tabs__item.is-active { border-bottom:2px solid #6b5dd5; }.legacy-order-page ::v-deep .tabs-list { margin-top:0; }.legacy-order-page h2 { margin:0 0 24px; font-size:26px; }.legacy-empty { min-height:380px; display:grid; place-items:center; color:#777780; font-size:14px; }.legacy-order-page button { border:1px solid #e9e9ef; border-radius:100px; padding:10px 16px; background:white; color:#6b5dd5; cursor:pointer; }.legacy-order-page ::v-deep .el-tabs__item.is-active { color:#6b5dd5; }.legacy-order-page ::v-deep .el-tabs__active-bar { background:#6b5dd5; }.legacy-order-page ::v-deep .center-order-table { max-width:100%; }.legacy-order-page :focus-visible { outline:2px solid #6b5dd5; outline-offset:3px; }@media(max-width:600px){.legacy-order-surface{padding:20px 16px;}.legacy-order-page ::v-deep .order-search{padding:10px;flex-wrap:wrap;}.legacy-order-page ::v-deep .condition-time{display:flex;flex-wrap:wrap;gap:8px;}.legacy-order-page ::v-deep .el-date-editor{max-width:100%;}}

	.center-lease-handle {
		display: block;
	}

	.center-lease-handle+.center-lease-handle {
		margin-top: 10px;
	}
</style>
